/**
 * Permission helpers for the SMS administration page (Issue #196).
 *
 * Mirrors the backend `PERMISSION_CATALOG` entries `sms_templates:read|write`
 * and `sms_logs:read` declared in `apps/api/src/auth/services/module-catalog.ts`
 * and seeded via the `20260517310000_seed_sms_permissions` migration. Frontend
 * nav gating cannot drift from backend `@RequirePermission(...)` decorators.
 */
import { hasPermission } from './crmPermissions';

export const SMS_PERMISSIONS = {
  TEMPLATES_READ: 'sms_templates:read',
  TEMPLATES_WRITE: 'sms_templates:write',
  LOGS_READ: 'sms_logs:read',
} as const;

export function canSeeSmsAdminMenu(permissions: readonly string[]): boolean {
  return (
    hasPermission(permissions, SMS_PERMISSIONS.TEMPLATES_READ) ||
    hasPermission(permissions, SMS_PERMISSIONS.LOGS_READ)
  );
}

export function canWriteSmsTemplates(permissions: readonly string[]): boolean {
  return hasPermission(permissions, SMS_PERMISSIONS.TEMPLATES_WRITE);
}
